<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="user-search-dialog-container">
  <div class="dialog-top-info">
    <h1 class="dialog-title" *ngIf="!selectedUser">
      {{ 'translations.mentors.label.selectMentor' | transloco }}
    </h1>
    <div class="admin-mentors__search" *ngIf="!selectedUser">
      <mat-form-field appearance="outline" class="search">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          [(ngModel)]="searchQuery"
          (input)="onSearchChangeDebounced()"
          maxlength="64"
          [attr.aria-label]="'translations.content.label.searchByName' | transloco"
          placeholder="{{ 'translations.content.label.searchByName' | transloco }}"
        />
      </mat-form-field>
    </div>
    <button
      class="close-dialog-btn"
      mat-icon-button
      color="primary"
      (click)="closeDialog()"
      [attr.aria-label]="'translations.global.ariaLabels.closeDialog' | transloco"
    >
      <svg class="svg" role="img">
        <use ogSvgUnify="assets/sprite/sprite.svg#close"></use>
      </svg>
    </button>
  </div>

  <div class="search-results-container" *ngIf="!selectedUser">
    <mat-spinner *ngIf="isLoading" class="loading-spinner"></mat-spinner>
    <ng-container *ngIf="!isLoading">
      <div class="mentors-grid">
        <div *ngFor="let user of mentors" class="mentor-card">
          <div class="mentor-top">
            <img [src]="user.imageUrl || 'assets/profile_image.png'" alt="{{ user.firstName }} {{ user.lastName }}" class="mentor-avatar" />
            <div class="mentor-top-info">
              <p class="mentor-name">{{ user.firstName }} {{ user.lastName }}</p>
            </div>
          </div>
          <p class="mentor-description">
            {{ user.description || ('translations.mentors.label.defaultMentorDescription' | transloco) }}
          </p>
          <button mat-stroked-button color="primary" (click)="selectUser(user)">
            {{ 'translations.global.button.select' | transloco }}
          </button>
        </div>
      </div>

      <ng-container *ngIf="mentors?.length === 0">
        <div class="empty-state-container">
          <mat-icon> person_off </mat-icon>
          <p class="empty-state-text">
            {{ 'translations.mentors.info.noMentorsAvailable' | transloco }}
          </p>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <ng-container *ngIf="selectedUser">
    <div class="mentor-card selected">
      <img
        [src]="selectedUser.imageUrl || 'assets/profile_image.png'"
        alt="{{ selectedUser.firstName }} {{ selectedUser.lastName }}"
        class="mentor-avatar"
      />
      <p class="mentor-name">{{ selectedUser.firstName }} {{ selectedUser.lastName }}</p>
      <p class="mentor-description">
        {{ selectedUser.description || ('translations.mentors.label.defaultMentorDescription' | transloco) }}
      </p>
    </div>
  </ng-container>

  <div class="dialog-footer-buttons" *ngIf="selectedUser">
    <button
      mat-flat-button
      type="button"
      color="accent"
      [attr.aria-label]="'translations.global.button.cancel' | transloco"
      (click)="deselectUser()"
      (keydown.enter)="deselectUser()"
    >
      {{ 'translations.global.button.cancel' | transloco }}
    </button>
    <button
      mat-raised-button
      type="button"
      color="primary"
      [attr.aria-label]="'translations.global.button.submit' | transloco"
      (click)="onSubmitClick()"
      (keydown.enter)="onSubmitClick()"
    >
      {{ submitButtonLabel }}
    </button>
  </div>
</div>
